import { reorderManyAnnotationsInStack } from '../utils/reorderAnnotationsInStack';

export const REORDER_ANNOTATIONS_STACKING = 'REORDER_ANNOTATIONS_STACKING';

const reorderAnnotationsStacking = (state, payload) => {
  const { annotationIds = [], direction, nextAnnotations } = payload;
  if (!direction || annotationIds.length === 0) {
    return state;
  }

  const annotations =
    nextAnnotations ??
    reorderManyAnnotationsInStack(
      state.annotations,
      annotationIds,
      direction,
    );

  if (annotations === state.annotations) {
    return state;
  }

  return {
    ...state,
    isDesignState: payload.isDesignState ?? true,
    annotations,
  };
};

export default reorderAnnotationsStacking;
